"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  name: {
    id: "window.charstats.title.charName",
    defaultMessage: "Name",
    description: "Name"
  },
  nation: {
    id: "window.charstats.title.nationName",
    defaultMessage: "Nation",
    description: "Nation"
  },
  guild: {
    id: "window.charstats.title.guildName",
    defaultMessage: "Guild",
    description: "Guild"
  },
  rank: {
    id: "window.charstats.title.rank",
    defaultMessage: "Rank",
    description: "Rank"
  },
  repute: {
    id: "window.charstats.title.repute",
    defaultMessage: "Reput.",
    description: "Reput."
  },
  class: {
    id: "window.charstats.title.className",
    defaultMessage: "Class",
    description: "Class"
  },
  level: {
    id: "window.charstats.title.level",
    defaultMessage: "Level",
    description: "Level"
  },
  exp: {
    id: "window.charstats.title.exp",
    defaultMessage: "EXP",
    description: "EXP"
  },
  hp: {
    id: "window.charstats.title.hp",
    defaultMessage: "H P",
    description: "HP"
  },
  mp: {
    id: "window.charstats.title.mp",
    defaultMessage: "M P",
    description: "MP"
  },
  sp: {
    id: "window.charstats.title.sp",
    defaultMessage: "S P",
    description: "SP"
  },
  vit: {
    id: "window.charstats.title.vit",
    defaultMessage: "VIT",
    description: "Vitality"
  },
  dex: {
    id: "window.charstats.title.dex",
    defaultMessage: "DEX",
    description: "Dexterity"
  },
  int: {
    id: "window.charstats.title.int",
    defaultMessage: "INT",
    description: "Intelligence"
  },
  str: {
    id: "window.charstats.title.str",
    defaultMessage: "STR",
    description: "Strength"
  },
  points: {
    id: "window.charstats.title.points",
    defaultMessage: "Points",
    description: "Points"
  },
  phyAtt: {
    id: "window.charstats.title.phyAtt",
    defaultMessage: "Phy Att.",
    description: "Physical Attack"
  },
  phyDef: {
    id: "window.charstats.title.phyDef",
    defaultMessage: "Phy Def.",
    description: "Physical Defense"
  },
  magAtt: {
    id: "window.charstats.title.magAtt",
    defaultMessage: "Mag Att.",
    description: "Magical Attack"
  },
  magDef: {
    id: "window.charstats.title.magDef",
    defaultMessage: "Mag Def.",
    description: "Magical Defense"
  },
  resist: {
    id: "window.charstats.title.resist",
    defaultMessage: "Resist",
    description: "Resistance"
  },
  resMelee: {
    id: "window.charstats.title.resist.melee",
    defaultMessage: "Melee",
    description: "Melee Resistance"
  },
  resRanged: {
    id: "window.charstats.title.resist.ranged",
    defaultMessage: "Ranged",
    description: "Ranged Resistance"
  },
  resAttack: {
    id: "window.charstats.title.resist.attack",
    defaultMessage: "Attack",
    description: "Attack Resistance"
  },
  resCurse: {
    id: "window.charstats.title.resist.curse",
    defaultMessage: "Curse",
    description: "Curse Resistance"
  }
});

exports.default = _default;